import { useMutation } from 'react-query'
import { checkExistingIso, addExistingIso } from 'services/iso'
import { IIsoCheckExistingDto, IIsoExistingDto, IIsoContactInfo } from 'typescript/interfaces/iso'
import { AxiosError } from 'axios'

interface UseIsoSearchResult {
  search: (values: IIsoCheckExistingDto) => void
  results: Array<IIsoExistingDto> | null | undefined
  isLoading: boolean
  error: AxiosError | null
  reset: () => void
}

export function useIsoSearch(onError?: (err: AxiosError) => void): UseIsoSearchResult {
  const [mutate, { data, isLoading, error, reset }] = useMutation(checkExistingIso, {
    onError: (err) => onError?.(err as AxiosError),
  })

  return {
    search: (values) => mutate(values),
    results: data?.data,
    isLoading,
    error: (error as AxiosError) || null,
    reset,
  }
}

interface UseAddExistingIsoResult {
  addIso: (values: IIsoContactInfo) => void
  isLoading: boolean
  error: AxiosError | null
  reset: () => void
}

export function useAddExistingIso(onSuccess?: () => void, onError?: (err: AxiosError) => void): UseAddExistingIsoResult {
  const [mutate, { isLoading, error, reset }] = useMutation(addExistingIso, {
    onSuccess: () => onSuccess?.(),
    onError: (err) => onError?.(err as AxiosError),
  })

  return {
    addIso: (values) => mutate(values),
    isLoading,
    error: (error as AxiosError) || null,
    reset,
  }
}
